import { combineReducers } from 'redux';

import { commonReducer } from 'common/redux';

import { assetsReducer } from 'components/AssetsList/redux/assets.reducer';
import { ordersReducer } from 'components/Orders/list/redux/orders.reducer';

import { derivativesReducer } from 'views/derivatives/redux/derivatives.reducer';
import { earnReducer } from 'views/earn/redux/earn.reducer';
import { exchangeReducer } from 'views/exchange/redux/exchange.reducer';
import { stocksReducer } from 'views/stocks/redux/stocks.reducer';
import { walletReducer } from 'views/wallet-new/redux/wallet.reducer';

import { socketReducer } from 'blocks/SocketProvider/redux/socket.reducer';

export default combineReducers({
  common: commonReducer,
  assetsReducer,
  walletReducer,
  ordersReducer,
  exchangeReducer,
  socketReducer,
  derivativesReducer,
  earnReducer,
  stocksReducer,
});
